export default __webpack_public_path__ + "72526128f50c154c4dd441dea1a46737.svg";